export default __webpack_public_path__ + "static/1-bee26bbcc437a7d03fbf2633ac4e76fc.png";